<template>
  <v-container ref="target">
    <div class="text-center">
      <SectionTitle class="d-inline-block">Aumente o faturamento com o Cardápio Digital no Tablet</SectionTitle>
      <p class="section-subtitle mt-4">
        O tablet de mesa trabalha por você: vende, agiliza e economiza — o dia inteiro, em cada mesa.
      </p>
    </div>

    <v-row class="mt-8">
      <v-col
        v-for="(pillar, index) in pillars"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        class="animated"
        :class="{ visible: showAll }"
        :style="{ animationDelay: `${index * 90}ms` }"
      >
        <div class="pillar-card">
          <div class="pillar-icon-wrap">
            <v-icon size="28" color="error">{{ pillar.icon }}</v-icon>
          </div>
          <h3 class="pillar-title">{{ pillar.title }}</h3>
          <p class="pillar-desc">{{ pillar.description }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';

  export default {
    name: 'TabletBenefitsSection',

    components: {
      SectionTitle,
    },

    data: () => ({
      showAll: false,
      pillars: [
        {
          icon: 'mdi-gesture-tap',
          title: 'Autoatendimento',
          description: 'O cliente pede sozinho, sem esperar o garçom — mais mesas atendidas e mais vendas.',
        },
        {
          icon: 'mdi-cart-plus',
          title: 'Aumento no ticket médio',
          description: 'Ticket médio até 60% maior, com fotos, destaques e promoções que estimulam o consumo.',
        },
        {
          icon: 'mdi-lightning-bolt',
          title: 'Agilidade',
          description: 'Pedidos vão direto para a cozinha, sem retrabalho e sem erros de anotação manual.',
        },
        {
          icon: 'mdi-account-cash',
          title: 'Menos mão de obra',
          description: 'Redução de até 50% da mão de obra, com menos erros e mais agilidade no atendimento.',
        },
        {
          icon: 'mdi-check-decagram',
          title: 'Zero erro manual',
          description: 'Elimina erros de anotação manual, com pedidos que vão direto para a cozinha e o PDV.',
        },
        {
          icon: 'mdi-monitor-shimmer',
          title: 'Vitrine que vende',
          description: 'Sempre ligado em modo vitrine, o tablet vira um outdoor na mesa que estimula o consumo.',
        },
      ],
    }),

    mounted() {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.showAll = true;
          observer.disconnect();
        }
      }, { threshold: 0.1 });

      observer.observe(this.$refs.target);
    },
  };
</script>

<style scoped lang="scss">
  .section-subtitle {
    font-size: 17px;
    line-height: 1.7;
    color: var(--text-muted);
    max-width: 620px;
    margin: 0 auto;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .pillar-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    padding: 26px 22px;
    height: 100%;
    border-radius: 16px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    transition: transform 0.28s ease, border-color 0.28s ease, box-shadow 0.28s ease;

    &:hover {
      transform: translateY(-6px);
      border-color: rgba(244, 6, 18, 0.45);
      box-shadow: 0 10px 28px rgba(244, 6, 18, 0.1);
    }
  }

  .pillar-icon-wrap {
    width: 58px;
    height: 58px;
    border-radius: 14px;
    background: rgba(244, 6, 18, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  }

  .pillar-title {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 8px;
    color: var(--text-primary);
  }

  .pillar-desc {
    font-size: 14px;
    color: var(--text-muted);
    line-height: 1.6;
    margin: 0;
  }

  .animated {
    opacity: 0;
    transform: translateY(28px);
    transition: opacity 0.45s ease, transform 0.45s ease;
  }

  .animated.visible {
    opacity: 1;
    transform: translateY(0);
  }
</style>
